import { Flag } from 'lucide-react';
import { EntradaDoNo } from './node-chrome';

/**
 * Fim explícito. O motor já encerra quando um nó não tem saída, mas um ramo
 * de condição/IA que "termina" precisa de um alvo para a aresta existir — sem
 * ela o motor cai na ordem posicional e manda o contato pelo outro ramo.
 */
export default function EndNode({ data }: any) {
  return (
    <>
      <EntradaDoNo />
      <div className="w-[140px] bg-white rounded-lg border border-border/60 shadow-sm overflow-hidden">
        <div className="h-1 bg-gray-400 rounded-t-lg" />
        <div className="flex items-center gap-2 p-3 text-xs font-semibold text-foreground">
          <Flag className="w-3.5 h-3.5 text-gray-500 shrink-0" strokeWidth={1.8} />
          <span>{data?.label || 'Fim do fluxo'}</span>
        </div>
      </div>
    </>
  );
}
